import { render, staticRenderFns } from "./PkgStdItemTxt.vue?vue&type=template&id=0e871147&"
import script from "./PkgStdItemTxt.vue?vue&type=script&lang=js&"
export * from "./PkgStdItemTxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports